import { Col, Row } from "reactstrap"
import styles from "./ProductDescCard.module.scss"

const ProductDescCard = ({ data }) => {
  return (
    <Row className="mt-2">
      <Col xs="auto">
        <div className="h-100 d-flex align-items-center">
          <div className="border rounded p-2">
            <img src={data.src || ""} alt="" width={41} height={41} />
          </div>
        </div>
      </Col>
      <Col xs='7'>
        <div className="fw-semibold">{data.title}</div>
        <div className="d-flex align-items-center gap-2">
          <div className={styles["serial-no"]}>{data.serialNumber}</div>
          <div>{data.items}</div>
        </div>
      </Col>
      <Col className="text-end">{data.totalSales}</Col>
    </Row>
  )
}

export default ProductDescCard
